import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "overline text-center mb-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    class: "mx-auto",
    "max-width": "344",
    raised: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_list_item, { "three-line": "" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "4" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_avatar, {
                    tile: "",
                    color: "grey",
                    size: "80",
                    rounded: "0"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_img, {
                        src: _ctx.match.posLeft.player.avatar
                      }, null, 8, ["src"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { cols: "4" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, "MATCH " + _toDisplayString(_ctx.tournament.currentRound), 1),
                  _createVNode(_component_v_list_item_title, { class: "headline text-center" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.match.posLeft.votes) + " VS " + _toDisplayString(_ctx.match.posRight.votes), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { cols: "4" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_avatar, {
                    tile: "",
                    size: "80",
                    color: "grey",
                    rounded: "0"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_img, {
                        src: _ctx.match.posRight.player.avatar
                      }, null, 8, ["src"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_card_actions, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_btn, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.vote(_ctx.match.posLeft.id))),
            disabled: _ctx.match.disabled
          }, {
            default: _withCtx(() => [
              _createTextVNode("Votar")
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_v_spacer),
          _createVNode(_component_v_btn, {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.vote(_ctx.match.posRight.id))),
            disabled: _ctx.match.disabled
          }, {
            default: _withCtx(() => [
              _createTextVNode("Votar")
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}